// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 14px;
  color: var(--color-topNav-text);
  -webkit-user-select: none;
          user-select: none;
}

.button-small {
  padding: 2px 6px;
  font-size: 10px;
}

.button-icon {
  padding: 4px 4px;
}

.button-icon-small {
  padding: 2px 2px;
  font-size: 10px;
}

button:hover {
  background-color: rgba(0, 0, 0, 0.0941176471);
}

.withoutHover {
  border-radius: 0;
}

.activeInactive {
  color: rgb(138, 138, 138);
  padding: 2px 0;
  border-radius: 0;
}

.activeInactiveActive {
  color: var(--color-topNav-text);
  border-bottom: 1px solid var(--color-featureColor);
}

.activeInactive:hover {
  background-color: transparent;
  color: var(--color-topNav-text);
}

.activeInactive[disabled]:hover {
  cursor: unset;
  background: transparent;
  color: rgb(138, 138, 138);
}

.dropdown {
  position: absolute;
  z-index: 1000;
  background: var(--color-dropdown-background);
  padding: 2px 4px;
  border-radius: 6px;
  border: 1px solid var(--color-dropdown-border);
  min-width: 240px;
}
.dropdown .dropdown-link {
  padding: 4px 18px;
  width: 100%;
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  color: var(--color-dropdown-text);
}
.dropdown .dropdown-link:hover {
  background: var(--color-featureColor);
  color: var(--color-dropdown-hoverBtn-text);
}`, "",{"version":3,"sources":["webpack://./src/components/button/button.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,6BAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,+BAAA;EACA,kDAAA;AACF;;AAEA;EACE,6BAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;EACA,gBAAA;AACF;AACE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,iCAAA;AACJ;AAEE;EACE,qCAAA;EACA,0CAAA;AAAJ","sourcesContent":["button {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  color: var(--color-topNav-text);\n  user-select: none; \n}\n\n.button-small {\n  padding: 2px 6px;\n  font-size: 10px;\n}\n\n.button-icon {\n  padding: 4px 4px;\n}\n\n.button-icon-small {\n  padding: 2px 2px;\n  font-size: 10px;\n}\n\nbutton:hover {\n  background-color: #00000018;\n}\n\n.withoutHover {\n  border-radius: 0;\n}\n\n.activeInactive {\n  color: rgb(138, 138, 138);\n  padding: 2px 0;\n  border-radius: 0;\n}\n\n.activeInactiveActive {\n  color: var(--color-topNav-text);\n  border-bottom: 1px solid var(--color-featureColor);\n}\n\n.activeInactive:hover {\n  background-color: transparent;\n  color: var(--color-topNav-text);\n}\n\n.activeInactive[disabled]:hover {\n  cursor: unset;\n  background: transparent;\n  color: rgb(138, 138, 138);\n}\n\n.dropdown {\n  position: absolute;\n  z-index: 1000;\n  background: var(--color-dropdown-background);\n  padding: 2px 4px;\n  border-radius: 6px;\n  border: 1px solid var(--color-dropdown-border);\n  min-width: 240px;\n\n  .dropdown-link {\n    padding: 4px 18px;\n    width: 100%;\n    font-size: 12px;\n    display: flex;\n    justify-content: flex-start;\n    color: var(--color-dropdown-text);\n  }\n\n  .dropdown-link:hover {\n    background: var(--color-featureColor);\n    color: var(--color-dropdown-hoverBtn-text);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
